import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Select } from '@components/core-ui/form-elements/Select';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { Content } from './AdminApplyEnhancementModal/styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  jobId: string;
  isReapply: boolean;
};

export const AdminApplyEnhancementModal = ({ onCancel, onSuccess, jobId, isReapply }: TProps) => {
  const [enhancedTranscriptMode, setEnhancedTranscriptMode] = useState<'auto' | 'force_asone' | 'force_assembly'>(
    'auto',
  );

  const { call } = useAPI();
  const title = isReapply ? 'Reapply AI Enhancement' : 'Apply AI Enhancement';

  const enhanceMutation = useMutation({
    mutationFn: () =>
      call(() =>
        AdminService.triggerEnhanceOnDemand({
          jobId,
          llmTranscriptSelectionMode: enhancedTranscriptMode,
        }),
      ),
    onSuccess: () => {
      toast.success('Submitted job for AI enhancement.');
      onSuccess();
    },
    onError: () => {
      toast.error('Unable to submit job for AI enhancement.');
    },
  });

  return (
    <ModalWrapper width="400px">
      {enhanceMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>{title}</ModalTitle>
      <Content>
        <div className="mb-8">
          <Select
            options={[
              { label: 'Auto', value: 'auto' },
              { label: 'Force ASOne transcript.json', value: 'force_asone' },
              { label: 'Force asr.json', value: 'force_assembly' },
            ]}
            label="Enhanced transcript selection"
            onChange={(_, value) => setEnhancedTranscriptMode(value as 'auto' | 'force_asone' | 'force_assembly')}
            value={enhancedTranscriptMode}
          />
          <small>Select which transcript to enhance</small>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            enhanceMutation.mutate();
          }}
        >
          <div className="buttonContainer">
            <OutlinedButton className="w-full" type="button" onClick={onCancel}>
              Cancel
            </OutlinedButton>
            <Button className="w-full" type="submit" disabled={enhanceMutation.isPending}>
              {isReapply ? 'Reapply' : 'Apply'}
            </Button>
          </div>
        </form>
      </Content>
    </ModalWrapper>
  );
};
